import moment from "moment";
import { LiaArrowAltCircleUpSolid } from "react-icons/lia";
import { MdOutlineFileDownload } from "react-icons/md";
import cn from "../../../lib/cn";
import P from "../../../shared/typography/P";
import PaymentStatus from "../../timeline/book-now/PaymentStatus";

const PaymentConfirmationCard = (item, handleApprove, setSelected) => {
    return (
        <div className="flex items-center gap-1 pb-1.5 mb-1.5 border-b border-blue-300">
            <div className="flex items-center justify-center h-3 w-3 bg-gray-60 rounded-full">
                <LiaArrowAltCircleUpSolid className="text-xxl text-gray-500" />
            </div>
            <div className="flex-1">
                <div className="flex justify-between items-center">
                    <P className="text-primary xl:text-sm 2xl:text-sm">
                        {item?.plantName}
                    </P>
                    <PaymentStatus
                        status={item?.paymentStatus?.toLowerCase()}
                        statusType={
                            item?.paymentStatus === "PAID"
                                ? "success"
                                : item?.paymentStatus === "PENDING"
                                ? "warn"
                                : "failed"
                        }
                    />
                </div>
                <P className="text-gray-370 !text-xs">
                    Investment Id #{item?.paymentId}
                </P>
                <div className="  flex gap-1 justify-between items-center">
                    <div>
                        <P className="text-gray-370 !text-xs">
                            {moment(item?.paymentDate * 1000).format(
                                "DD/MM/yyyy"
                            )}
                        </P>
                    </div>
                    <div>
                        <P className="xl:text-sm 2xl:text-sm">
                            ₹ {item?.paymentAmount}
                        </P>
                    </div>
                </div>
                <div
                    className={cn("flex justify-between items-center", {
                        "justify-end": item?.paymentStatus !== "PENDING",
                    })}
                >
                    {item?.paymentStatus === "PENDING" && (
                        <button
                            className="text-blue text-xs underline mt-0.2"
                            onClick={() => {
                                setSelected(item);
                                handleApprove();
                            }}
                        >
                            Approve Payment
                        </button>
                    )}
                    <button className="text-blue flex gap-0.5 text-xs underline mt-0.2">
                        Receipt <MdOutlineFileDownload />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentConfirmationCard;
